/* Tysk katalog for locale-sales-payments-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inv.unknownAccount': 'Unbekanntes Konto',
  'inv.refund.customerBalance': "Kundenguthaben",
  'inv.refund.balanceHelp': "Der Saldo umfasst die Gutschriften sowie die unten aufgeführten Ein- und Rückzahlungen.",
  'inv.refund.addFee': "Gebühr hinzufügen",
  'inv.refund.businessFee': "Vom Unternehmen gezahlte Gebühr",
  'inv.refund.customerReceives': "Kunde erhält",
  'inv.refund.accountDebit': "Gesamte Kontobelastung",
  'sale.pay.ownerDebt': "Kurzfristige Verbindlichkeiten gegenüber Eigentümern",
  'sale.pay.title': 'Zahlung',
  'sale.pay.help': 'Wähle, auf welches Konto und an welchem Datum der Verkauf bezahlt wurde. Füge eine Gebühr hinzu oder teile die Zahlung in mehrere Teilzahlungen auf. Die Summe muss mit den Verkaufszeilen übereinstimmen.',
  'sale.pay.paidTo': 'Bezahlt auf',
  'sale.pay.choosePaymentAccount': 'Zahlungskonto wählen',
  'sale.create.needPaymentAccount': 'Wähle „Bezahlt auf“, bevor du den Verkauf erfasst.',
  'sale.pay.paidDate': 'Zahlungsdatum',
  'sale.pay.fee': 'Gebühr',
  'sale.pay.addFee': 'Gebühr hinzufügen',
  'sale.pay.removeFee': 'Gebühr entfernen',
  'sale.pay.partial': 'Teilzahlungen',
  'sale.pay.addPartial': 'Teilzahlung hinzufügen',
  'sale.pay.removePartial': 'Teilzahlung entfernen',
  'sale.pay.seeTransaction': 'Transaktion ansehen',
  'sale.pay.addAccount': 'Konto hinzufügen',
  'sale.pay.addCard': 'Kreditkarte hinzufügen',
  'sale.pay.addBankTitle': 'Bankkonto hinzufügen',
  'sale.pay.addCardTitle': 'Kreditkarte hinzufügen',
  'sale.pay.addSolutionTitle': 'Zahlungslösung hinzufügen',
  'sale.pay.solution': 'Zahlungslösung',
  'sale.pay.accountType': 'Kontotyp',
  'sale.pay.cardOwner': 'Die Karte gehört',
  'sale.pay.displayName': 'Anzeigename (optional)',
  'sale.pay.orgNumber': 'Org.-Nummer',
  'sale.pay.openingBalance': 'Anfangssaldo für die Abstimmung',
  'sale.pay.openingBalanceDate': 'Datum des Anfangssaldos',
  'sale.pay.resetChoice': 'Auswahl zurücksetzen',
  'sale.cust.helpTitle': 'Kunde des Verkaufs',
  'sale.cust.help': 'Hier wählst du, wen der Verkauf betrifft. Suche einen gespeicherten Kunden, eine Liste oder ein Abonnement – oder tippe auf „Neuer Kunde“, um einen noch nicht gespeicherten Empfänger einzugeben. Name und Adresse werden automatisch in das Dokument übernommen.',
  'sale.cust.optionalHelp': 'Bei sonstigen Verkäufen ist der Kunde optional. Aktiviere die Option, wenn du den Verkauf mit einem bestimmten Kunden verknüpfen möchtest.',
  'sale.cust.search': 'Kunden, Listen und Abonnements durchsuchen...',
  'sale.cust.pickExisting': 'Bestehenden wählen',
  'sale.cust.new': 'Neuer Kunde',
  'sale.cust.add': 'Kunde hinzufügen',
  'sale.cust.selected': 'Ausgewählter Kunde',
  'sale.cust.selectedList': 'Ausgewählte Empfängerliste',
  'sale.cust.none': 'Noch kein Kunde ausgewählt',
  'sale.cust.listsAndSubs': 'Listen und Abonnements',
  'sale.cust.detailsTitle': 'Kundendetails',
  'sale.cust.name': 'Kundenname',
  'sale.cust.namePh': 'z. B. Beispiel AS',
  'sale.cust.number': 'Kundennr.',
  'sale.cust.org': 'Org.-Nr.',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adresse',
  'sale.cust.addressPh': 'Straße, PLZ und Ort',
  'sale.cust.email': 'E-Mail',
  'sale.cust.emailPh': 'post@beispiel.de',
  'sale.cust.phone': 'Telefon',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Kontaktpersonen',
  'sale.cust.noContacts': 'Keine Kontaktpersonen hinzugefügt.',
  'sale.cust.addContact': 'Kontaktperson hinzufügen',
  'sale.cust.removeContact': 'Kontaktperson entfernen',
  'sale.cust.contactName': 'Name',
  'sale.cust.contactNamePh': 'z. B. Erika Mustermann',
  'sale.cust.contactRole': 'Rolle',
  'sale.cust.contactRolePh': 'z. B. Buchhaltung',
  'sale.cust.outstanding': 'Offen',
  'sale.cust.revenueToDate': 'Umsatz bisher',
  'sale.cust.pickPh': 'Kunde oder Nummer',
  'sale.cust.select': 'Kunde wählen',
  'sale.cust.use': 'Kunde verwenden',
  'sale.cust.noEmail': 'Keine E-Mail beim Kunden',
  'sale.cust.listDefaultName': 'Kundenliste',
  'sale.cust.updatedToast': 'Kunde im Verkauf aktualisiert',
  'sale.cust.noCustomerHelp': 'Der Verkauf wird ohne Kunden erfasst. Aktiviere den Schalter, wenn du ihn mit einem Kunden verknüpfen möchtest.',
  'sale.cust.selectHint': 'Wähle einen gespeicherten Kunden, eine Liste oder ein Abonnement - oder nutze „Neuer Kunde“ für freie Eingabe.',
  'sale.cust.recipientsCount': '{count} Empfänger',
  'sale.cust.kindSubscription': 'Abonnement',
  'sale.cust.kindList': 'Liste',
  'sale.cust.noMatches': 'Keine Treffer für „{query}“.',
  'sale.cust.addAsNew': '„{query}“ als neuen Kunden hinzufügen',
  'sale.cust.contactDefaultName': 'Kontaktperson {n}',
  'sale.cust.saveFailed': 'Der Kunde konnte nicht gespeichert werden.',
  'sale.pay.accountNameSavings': 'Sparkonto',
  'sale.pay.accountNameOperating': 'Geschäftskonto',
  'sale.pay.accountNamePrivate': 'Privatkonto',
  'sale.pay.accountNameBank': 'Bankkonto',
  'sale.pay.groupBank': 'Bankkonten',
  'sale.pay.groupCard': 'Kreditkarten',
  'sale.pay.groupPrivate': 'Privat',
  'sale.pay.groupOther': 'Sonstiges',
  'sale.pay.groupGeneric': 'Konten',
  'sale.pay.cashLabel': 'Bar',
  'sale.pay.bankNameRequired': 'Gib dem Bankkonto einen Namen',
  'sale.pay.accountOrCardNameRequired': 'Gib dem Konto oder der Karte einen Namen',
  'sale.pay.accountNumberRequired': 'Kontonummer eingeben',
  'sale.pay.bankAccountAdded': 'Bankkonto hinzugefügt',
  'sale.pay.privateAccountAdded': 'Privatkonto hinzugefügt',
  'sale.pay.saveAccountFailed': 'Konto konnte nicht gespeichert werden.',
  'sale.pay.accountsUnavailable': 'Zahlungskonten sind nicht mit dem Backend verbunden.',
  'sale.pay.openingSetupRequired': 'Gib Startdatum und Anfangssaldo ein. Gib 0 ein, wenn der Saldo null war.',
  'sale.pay.invalidLedgerAccount': 'Im Kontenplan fehlt eine gültige Kontonummer.',
  'sale.pay.accountExists': 'Konto {code} existiert bereits.',
  'sale.pay.typePrivateCard': 'Privatkonto / Karte',
  'sale.pay.newBankAccountNote': 'Ein neues Bankkonto wird im Kontenplan angelegt',
  'sale.pay.newPrivateAccountNote': 'Ein neues Privatkonto bzw. eine neue Karte wird im Kontenplan angelegt',
  'sale.pay.bankAccountSeriesInfo': 'Bankkonten erhalten das nächste freie Konto der 192x-Reihe.',
  'sale.pay.privateAccountSeriesInfo': 'Private Karten/Konten erhalten das nächste freie Verrechnungskonto der 206x-Reihe.',
  'sale.pay.thisGetsAccount': 'Erhält das Konto',
  'sale.pay.accountNameLabel': 'Kontoname',
  'sale.pay.accountOrCardNameLabel': 'Name des Kontos / der Karte',
  'sale.pay.accountNamePhBank': 'z. B. Geschäftskonto 2',
  'sale.pay.accountNamePhPrivate': 'z. B. Inhaberkarte Visa',
  'sale.pay.accountNumberLabel': 'Kontonummer',
  'sale.pay.accountCardRefLabel': 'Konto / Kartennummer / Referenz (optional)',
  'sale.pay.interimAccountPrefix': 'Verrechnung',
  'sale.pay.cardNameRequired': 'Gib der Kreditkarte einen Namen',
  'sale.pay.cardNumberRequired': 'Karten-/Kontonummer eingeben',
  'sale.pay.openingBalanceRequired': 'Anfangssaldo und Datum des Anfangssaldos eingeben',
  'sale.pay.creditCardDebtPrefix': 'Kreditkartenschuld',
  'sale.pay.cardAdded': 'Kreditkarte hinzugefügt',
  'sale.pay.saveCardFailed': 'Kreditkarte konnte nicht gespeichert werden.',
  'sale.pay.scopeBusiness': 'Unternehmen',
  'sale.pay.businessCardNote': 'Firmenkarten werden als eigene Kartenschuld gebucht',
  'sale.pay.privateCardNote': 'Private Karten werden als Verrechnung gebucht',
  'sale.pay.businessCardSeriesInfo': 'Firmenkarten, die kein Bankkonto sind, erhalten das nächste freie Konto der 238x-Reihe.',
  'sale.pay.privateCardSeriesInfo': 'Private Karten erhalten das nächste freie Verrechnungskonto der 206x-Reihe.',
  'sale.pay.accountInLedger': 'Konto in der Buchhaltung:',
  'sale.pay.cardNamePhBusiness': 'z. B. Firmenkarte Visa',
  'sale.pay.cardNamePhPrivate': 'z. B. Inhaberkarte Mastercard',
  'sale.pay.cardNumberLabel': 'Kartennummer / Kontonummer',
  'sale.pay.cardNumberLabelOptional': 'Kartennummer / Kontonummer (optional)',
  'sale.pay.otherSolution': 'Andere Zahlungslösung',
  'sale.pay.settlementPrefix': 'Abrechnung',
  'sale.pay.solutionAdded': 'Zahlungslösung hinzugefügt',
  'sale.pay.saveSolutionFailed': 'Zahlungslösung konnte nicht gespeichert werden.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe und Ähnliche werden auf einem eigenen Abrechnungskonto für die Zahlungslösung gebucht, das abgestimmt wird, sobald die Abrechnung auf das Bankkonto ausgezahlt ist.',
  'sale.pay.addCardAction': '+ Kreditkarte hinzufügen ...',
  'sale.pay.addSolutionAction': '+ Zahlungslösung hinzufügen ...',
  'sale.pay.partialLabel': 'Teilzahlung {n}',
  'sale.pay.partialStatusRemaining': 'offen',
  'sale.pay.partialStatusTooMuch': 'zu viel',
  'sale.pay.partialStatusMatches': 'stimmt',
  'sale.pay.partialSummary': 'Bezahlt {paid} von {expected} · {status}',
  'sale.pay.partialMismatch': 'Die Summe der Teilzahlungen muss der Verkaufssumme{feeSuffix} entsprechen ({expected}).',
  'sale.list.noMembers': 'Die Liste enthält keine Kunden zum Abrechnen.',
  'sale.list.customerMissing': 'Den Kunden gibt es nicht mehr.',
  'sale.list.noneCreated': 'Es wurden keine Rechnungen erstellt.',
  'sale.list.missingEmailNotice': '{count} Rechnungen wurden für Kunden ohne E-Mail erstellt und müssen manuell gesendet oder gedruckt werden: {names}',
  'sale.list.notCreatedNotice': 'Nicht abgeschlossen für: {names}',
  'sale.list.createdNoEmail': 'Die Rechnung wurde erstellt, aber der Kunde hat keine E-Mail. Sende oder drucke sie manuell.',
  'sale.list.noneSent': 'Die Rechnungen wurden erstellt, aber keine wurde per E-Mail gesendet. Manuell senden oder drucken: {names}',
  'sale.list.recipientsCount': '{count} Empfänger',
  'sale.list.sentPartly': 'An {sent} Empfänger gesendet. Nicht gesendet: {names}',
  'sale.list.sentAll': 'An {sent} Empfänger gesendet.',
  'sale.pay.partialMismatchFeeSuffix': ' abzüglich Gebühr',
  'sale.pay.feeTooHigh': 'Die Gebühr darf nicht größer als der Verkauf sein ({gross}).',
  'sale.pay.splitMismatchError': 'Die Teilzahlungen ({paid}) müssen zusammen der Verkaufssumme abzüglich Gebühr entsprechen ({expected}).',
  'sale.product.backendUnavailable': 'Das Speichern von Produkten ist nicht mit dem Backend verbunden.',
  'sale.product.added': 'Produkt „{name}“ hinzugefügt',
  'sale.product.updated': 'Produkt „{name}“ aktualisiert',
  'sale.product.saveFailed': 'Das Produkt konnte nicht gespeichert werden.',
  'sale.create.backendUnavailable': 'Neuer Verkauf ist nicht mit dem Backend verbunden.',
});
